/* eslint-disable camelcase, @typescript-eslint/naming-convention */
/**
 * AI Block Types — Response Protocol Contract
 *
 * Defines all TypeScript interfaces for the block-based response envelope
 * between the LangGraph orchestrator and the frontend chat UI.
 *
 * Property names use snake_case to match the wire protocol from the backend.
 *
 * Source of truth: docs/ai-knowledge/features/chat-widget-response-protocol.md
 *
 * @version 1.0.0
 * @since 2026-02-18
 */
/**
 * Which backend minted a `file_download` block's URL, and therefore which one
 * can mint a replacement. Two produce downloads today: the orchestrator's own
 * generated-file store, and a Rails-side CSV export job.
 *
 * Declared as a runtime tuple so the union and the list of sources are the same
 * object — a third source added here cannot go untested, because the renderer's
 * tests enumerate this array.
 */
export const DOWNLOAD_SOURCES = ['ai_generated_file', 'rails_csv_export'];
// ---------------------------------------------------------------------------
// SSE Event Types
// ---------------------------------------------------------------------------
/**
 * An undo the orchestrator has just settled server-side (IP-15624).
 *
 * Declared as a const so the event name and the `SSEEventType` member below are
 * the same string: handlers key off this, and a typo is a compile error rather
 * than a handler that is registered under a name the stream never sends.
 */
export const UNDO_SETTLED_SSE_EVENT = 'undo_settled';
